import React, { useState } from "react";
import Container from "../../../utils/Container";
import Bookings from "./sections/Bookings";
import Profile from "./sections/Profile";
import { secureStorage } from "../../../utils/secureStorage";
import { useNavigate } from "react-router";
import { useAuth } from "../../../utils/useAuth";
import { FiCalendar, FiUser, FiLock, FiLogOut } from "react-icons/fi";
import ChangePassword from "./sections/ChangePassword";

const NAV = [
  { id: 1, label: "My Bookings", icon: FiCalendar },
  { id: 2, label: "Profile", icon: FiUser },
  { id: 3, label: "Change Password", icon: FiLock },
];

const Dashboard = () => {
  const [Tab, setTab] = useState(1);
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleLogout = () => {
    secureStorage.removeItem("accessToken");
    secureStorage.removeItem("user");
    navigate("/");
  };

  const initials = (user?.fullName || "U")
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <div className="w-full py-6 lg:py-10 min-h-[500px] bg-[#f0f8fd]">
      <Container>
        <div className="flex flex-col lg:flex-row gap-5">
          {/* SIDEBAR */}
          <aside className="w-full lg:w-[280px] shrink-0">
            <div className="border rounded-xl bg-white overflow-hidden sticky top-5">
              {/* user mini card */}
              <div className="p-4 flex items-center gap-3 border-b bg-gradient-to-r from-[#e7f3fe] to-white">
                <div className="w-11 h-11 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold shrink-0">
                  {initials}
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-gray-800 truncate">
                    {user?.fullName || "User"}
                  </p>
                  <p className="text-xs text-gray-500 truncate">
                    {user?.email}
                  </p>
                </div>
              </div>

              {/* nav */}
              <nav className="p-2 space-y-1">
                {NAV.map(({ id, label, icon: Icon }) => {
                  const active = Tab === id;
                  return (
                    <button
                      key={id}
                      onClick={() => setTab(id)}
                      className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium duration-200 ${
                        active
                          ? "bg-blue-600 text-white"
                          : "text-gray-700 hover:bg-[#d2e9fc]"
                      }`}
                    >
                      <Icon className="text-base" />
                      {label}
                    </button>
                  );
                })}
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-red-500 hover:bg-red-50 duration-200"
                >
                  <FiLogOut className="text-base" />
                  Logout
                </button>
              </nav>
            </div>
          </aside>

          {/* CONTENT */}
          <main className="flex-1 min-w-0 p-4 lg:p-6 border rounded-xl bg-white">
            {Tab === 1 && <Bookings />}
            {Tab === 2 && <Profile />}
            {Tab === 3 && <ChangePassword />}
          </main>
        </div>
      </Container>
    </div>
  );
};

export default Dashboard;
